import { render, staticRenderFns } from "./FileAttachments.vue?vue&type=template&id=144a4ee8&scoped=true&"
import script from "./FileAttachments.vue?vue&type=script&lang=js&"
export * from "./FileAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a4ee8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144a4ee8')) {
      api.createRecord('144a4ee8', component.options)
    } else {
      api.reload('144a4ee8', component.options)
    }
    module.hot.accept("./FileAttachments.vue?vue&type=template&id=144a4ee8&scoped=true&", function () {
      api.rerender('144a4ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/templates/invoices/schema/FileAttachments.vue"
export default component.exports